import { Component, Input } from '@angular/core';

@Component({
  templateUrl: './park-schedule-item.html',
  selector: 'park-schedule-item'
})
export class ParkScheduleItemComponent {
  @Input() schedule: any;
  @Input() scheduleId: any;
  @Input() park: any;
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/schedules/park-schedule-item/park-schedule-item.component.ts